import $ from 'jquery';

const dynamicMyAccountTitle = () => {
	const el = {
		nav_link: '.woocommerce-MyAccount-navigation-link',
		is_active: '.is-active',
		title: 'h1.elementor-heading-title, .woocommerce h1',
	};

	const init = () => {
		// $(function () {
		if (!$(el.nav_link).length) return;

		exec();
		// });
	};

	const exec = () => {
		if ($(`${el.nav_link}${el.is_active}`).length) {
			const title = $(`${el.nav_link}${el.is_active}`).text().trim();

			if (title.toLowerCase() !== 'dashboard') $(el.title).text(title);
		}
	};

	init();
};

try {
	dynamicMyAccountTitle();
} catch (error) {
	console.error(error);
}
